import { FunctionComponent, useState } from 'react'
import { MdCloudDownload, MdLocalOffer, MdPlace } from 'react-icons/md'
import { useHistory, useLocation } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import iconEspecie from 'shared/assets/icons/drive/icon-especie.svg'
import iconFilial from 'shared/assets/icons/drive/icon-filial.svg'
import iconPedagio from 'shared/assets/icons/drive/icon-pedagio.svg'
import Button from 'shared/components/Button'
import ContainerPage from 'shared/components/ContainerPageNew'
import LabelValue from 'shared/components/LabelValue/LabelValue'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import IFindByCodigoOcOuLoteSolicitadoIdImpl from 'shared/modules/ordemCarregamento/domain/usecases/FindByCodigoOcOuLoteSolicitadoIdImpl'
import { colors } from 'shared/styles/colors'
import { numberToCurrency } from 'shared/utils/formatters'
import { iconProdutoLote } from 'shared/utils/iconProdutoLote'
import ISendSmsImpl from 'modules/lotesSolicitados/domain/usecases/SendSmsImpl'
import { useAuth } from 'modules/auth/hooks/auth'

import ILoteSolicitado from '../../domain/entities/LoteSolicitado'
import { EStatusConjunto } from '../utils/EStatusConjunto'
import { ELockOCMessageTypes } from '../utils/ELockOCMessage'
import ModalWaitForNotification from '../components/ModalWaitForNotification'
import ModalSemCadencia from '../components/ModalSemCadencia'
import ModalReprovadoGr from '../components/ModalReprovadoGr'
import ModalAguardandoValidacao from '../components/ModalAguardandoValidacao'

type TProps = {
  findByCodigoOcOuLoteSolicitadoId: IFindByCodigoOcOuLoteSolicitadoIdImpl
  sendSms: ISendSmsImpl
}

type TLocation = {
  lote: ILoteSolicitado
}

function reprovadoGR(statusGR: EStatusConjunto, statusOP: EStatusConjunto) {
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.LIBERADO
  ) {
    return true
  }
  return false
}

function semCadencia(statusGR: EStatusConjunto, statusOP: EStatusConjunto) {
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.LIBERADO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  return false
}

function aguardandoValidacao(
  statusGR: EStatusConjunto,
  statusOP: EStatusConjunto,
) {
  if (
    statusGR === EStatusConjunto.LIBERADO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.LIBERADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  return false
}

const DetalhesLoteSolicitado: FunctionComponent<TProps> = ({
  findByCodigoOcOuLoteSolicitadoId,
  sendSms,
}) => {
  const {
    state: { lote },
  } = useLocation<TLocation>()
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState('')
  const [modalAlertType, setAlertType] = useState<ELockOCMessageTypes>()
  const [smsConfig, setSmsConfig] = useState(false)
  const [telefoneSms, setTelefoneSms] = useState('')
  const { telefone } = useAuth()

  const handleOrdemCarregamento = async () => {
    setLoading(true)
    try {
      const response = await findByCodigoOcOuLoteSolicitadoId.execute({
        lote_solicitado_id: lote.id,
        type: 'url',
        ordem_carregamento_codigo: lote.ordem_carregamento_codigo,
      })
      setLoading(false)
      window.open(response, '_blank')
    } catch (error: any) {
      const msg = JSON.parse(error.message)
      if (reprovadoGR(msg.status_GR, msg.status_OP)) {
        setAlertType(ELockOCMessageTypes.REPROVADO_GR)
      } else if (semCadencia(msg.status_GR, msg.status_OP)) {
        setAlertType(ELockOCMessageTypes.SEM_CADENCIA)
      } else if (aguardandoValidacao(msg.status_GR, msg.status_OP)) {
        if (lote.send_sms === null) {
          setAlertType(ELockOCMessageTypes.AGUARDANDO_VALIDACAO)
        } else {
          if (lote.send_sms === null) {
            setAlertType(ELockOCMessageTypes.AGUARDANDO_VALIDACAO)
          } else {
            setSmsConfig(lote.send_sms)
            setAlertType(ELockOCMessageTypes.WAIT_FOR_NOTIFICATION)
          }
        }
      } else {
        setMessages(
          'Não foi possível gerar a ordem de carregamento, por favor tente novamente em alguns minutos.',
        )
        setOpen(true)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <ContainerPage
      breadCrumb="Ofertas de cargas / Ofertas enviada / Detalhe de carga solicitada"
      showFooterScaffold={true}
      titleNextButton="Ok"
      title="Detalhe da carga"
      onClickNextButton={() => history.push('/lotes-solicitados')}
    >
      {loading ? (
        <LoadingBackdrop open={loading} color={colors.green} />
      ) : (
        <>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <LabelValue title="Frete" value={'#' + lote?.id.toString()} />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Lote"
                value={'#' + lote?.tmov_lote_id?.toString()}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={6}>
              <LabelValue
                icon={MdPlace}
                title="Origem"
                value={lote?.origem_completa}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                icon={MdPlace}
                title="Destino"
                value={lote?.destino_completo}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={6}>
              <LabelValue
                icon={MdLocalOffer}
                title="Valor"
                value={numberToCurrency(lote?.valor)}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Espécie"
                value={lote?.especie}
                iconFile={iconEspecie}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={6}>
              <LabelValue
                title="Produto"
                value={lote?.produto}
                iconFile={iconProdutoLote(lote?.produto)}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Pedágio"
                value={lote?.pedagio}
                iconFile={iconPedagio}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={6}>
              <LabelValue
                title="Total do pedágio na rota"
                value={numberToCurrency(lote?.total_pedagio)}
                iconFile={iconPedagio}
              />
            </Grid>
            <Grid item xs={6}>
              <LabelValue
                title="Filial"
                value={lote?.filial}
                iconFile={iconFilial}
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <LabelValue title="Observações" value={lote?.observacao} />
          </Grid>

          <Grid container justifyContent={'flex-start'}>
            <Button
              onClick={handleOrdemCarregamento}
              color={colors.lightBlue}
              style={{ margin: '20px 20px 20px 0px' }}
              aria-label="btn-baixar-oc-1"
            >
              <MdCloudDownload />
              Baixar O.C
            </Button>
          </Grid>
        </>
      )}

      <ModalReprovadoGr
        openModal={modalAlertType === ELockOCMessageTypes.REPROVADO_GR}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      />
      <ModalSemCadencia
        openModal={modalAlertType === ELockOCMessageTypes.SEM_CADENCIA}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      />
      <ModalAguardandoValidacao
        loteId={lote.id}
        openModal={modalAlertType === ELockOCMessageTypes.AGUARDANDO_VALIDACAO}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
        sendSms={sendSms}
        telefone={telefoneSms}
      />
      <ModalWaitForNotification
        openModal={modalAlertType === ELockOCMessageTypes.WAIT_FOR_NOTIFICATION}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
        smsConfig={smsConfig}
      />
      <SnackBar
        open={open}
        message={messages}
        setOpen={setOpen}
        severity={'error'}
      />
    </ContainerPage>
  )
}

export default DetalhesLoteSolicitado
